import { ConfigurationTemplate } from "@/model/data/security/ConfigurationTemplate";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class GetTemplatesResData extends ApiGenericResponse {
    configurationTemplates: Array<ConfigurationTemplate>;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.ConfigurationTemplates) {
            this.configurationTemplates = new Array<ConfigurationTemplate>();
            obj.ConfigurationTemplates.forEach((template) => {
                let t = new ConfigurationTemplate();
                t.parse(template);
                this.configurationTemplates.push(t);
            });
        }
    }
}
